import angular from "angular";
import imageService from './image.service';

let imageModule = angular.module('image.service', [])
.service('Image', imageService)

.name;

export default imageModule;



// WEBPACK FOOTER //
// ./client/app/services/imageService/image.js